import { SelectItem } from 'bones/design-system/utils/select/types';

export const createItem = <T extends SelectItem | null = null>(
  text: string,
  value: string,
  options?: Omit<T, 'text' | 'value'>
) => ({ text, value, ...options } as SelectItem<T>);
